import type { Action } from 'redux';

export interface ScrollState {
  senderComponent: string | null;
}

interface SetScrollSenderComponentAction extends Action {
  type: 'SET_SCROLL_SENDER_COMPONENT';
  senderComponent: string | null;
}

interface SetApplicationActiveFulfilledAction extends Action {
  type: 'SET_APPLICATION_ACTIVE_FULFILLED';
}

type ScrollAction = SetScrollSenderComponentAction | SetApplicationActiveFulfilledAction;

const defaultState: ScrollState = {
  senderComponent: null,
};

function reducer(state: ScrollState = defaultState, action: ScrollAction): ScrollState {
  switch (action.type) {
    case 'SET_SCROLL_SENDER_COMPONENT': {
      return {
        ...state,
        senderComponent: action.senderComponent,
      };
    }
    case 'SET_APPLICATION_ACTIVE_FULFILLED': {
      return {
        ...defaultState,
      };
    }
    default:
      return state;
  }
}

export default reducer;
